import { NestedTranslations } from '../../models/nested-translations.model';
import { RecursiveTranslation } from '../../models/recursive-translation.model';
import { TranslationPlaceholders } from '../../models/translation-placeholders.model';
import { Formatter } from '../formatter/formatter.utils';

const formatValue = (formatter: Formatter, value: string | number | Date) => {
   if (value instanceof Date) return formatter.dateTime(value);
   if (typeof value === 'number') return formatter.number(value);
   return value?.toString();
};

export const translate = (
   formatter: Formatter,
   key: string,
   translations: NestedTranslations | null,
   fallback: NestedTranslations | null,
   placeholders?: TranslationPlaceholders,
   forceFallback?: boolean
): string => {
   if (!translations && !fallback) {
      return key;
   }

   const translationReducer = (acc: RecursiveTranslation | undefined, keyPart: string): RecursiveTranslation | undefined => {
      if (!acc) return undefined;
      if (typeof acc === 'string') return undefined;
      return acc[keyPart];
   };

   const keyParts = key.split('.');
   const translation = forceFallback
      ? keyParts.reduce(translationReducer, fallback || {})
      : keyParts.reduce(translationReducer, translations || {}) ?? keyParts.reduce(translationReducer, fallback || {});

   if (typeof translation !== 'string') return key;

   if (!placeholders) return translation;

   return Object.keys(placeholders).reduce(
      (acc, placeholderKey) => acc.replaceAll(`{{${placeholderKey}}}`, formatValue(formatter, placeholders[placeholderKey])),
      translation
   );
};
